import React from 'react'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import MailingLists from 'admin/mailing_lists//MailingLists'
import LeftIndent from 'utils/LeftIndent';

class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabLocation: ""
    }
  }
  componentDidMount()
  {
    let hashLoc = location.hash.replace("#", "");
    if (hashLoc != "") {
      this.setState({tabLocation: hashLoc})
    }
    else {
      location.hash = "#mailingLists"
      this.setState({tabLocation: "mailingLists"})
    }
  }

  selectTab (key)
  {
    location.hash = "#" + key
    this.setState({tabLocation: key})
  }

  render() {
    return (
      <>
        <h1>Admin Settings</h1>
        <Tab.Container className="" id="admin-tabs" defaultActiveKey="userAccess" activeKey={this.state.tabLocation} onSelect={(k) => this.selectTab(k)}>
          <Nav variant="pills" className="nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-2">
              <Nav.Item className="col">
                <Nav.Link eventKey="mailingLists">Mailing Lists</Nav.Link>
              </Nav.Item>
              <Nav.Item className="col">
                <Nav.Link eventKey="refreshData">Refresh Data</Nav.Link>
              </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="mailingLists">
              <LeftIndent>
                <MailingLists mailingLists={this.props.mailingLists} />
              </LeftIndent>
            </Tab.Pane>
            <Tab.Pane eventKey="refreshData">
              <LeftIndent>
                <div className="off-color-bg standard-page-padding">
                  This tool is coming soon!?
                </div>
              </LeftIndent>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </>
    );
  }
}

export default Admin;
